import { makeStyles } from 'tss-react/mui';
import { rawContentBlockStyles } from './../../styles/jss/contentBlock';
import { spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '790px',
        margin: '0 auto',
    },
    deliveryPassHeading: {
        marginBottom: '50px',
    },
    errorMessage: {
        marginBottom: spacing.xs,
    },
    headingSection: Object.assign({}, rawContentBlockStyles(theme).headingSection),
    message: {
        color: theme.isFlyingFlowers ? colors.black[700] : undefined,
    },
    deliveryPassesContainer: {
        display: 'flex',
        '& > *:not(:last-child)': {
            marginRight: spacing.medium,
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            '& > *:not(:last-child)': {
                marginRight: '0',
                marginBottom: spacing.medium,
            },
        },
    },
}));
export default useStyles;
